/**************************************************
 * Nombre:       Formacion_Perfil_Ocupacional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import iso from "../../../Recursos/iso_azul.svg";
import {NEGRITA} from "../../../Constantes";
import Tarjeta_Perfil_Ocupacional from "../../Tarjetas/Tarjeta_Perfil_Ocupacional";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../../Dialogos/Dialogo_Wass";


const Formacion_Perfil_Ocupacional = () => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Inciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 9}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 3,
                    height: 350
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() =>  abrir({asunto: 'Pefil ocupacion del tecnico'})}
                        color={'secondary'}
                            startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                        Mas informacion
                    </Button>
                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: -36}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontFamily: NEGRITA, fontSize: 48, fontWeight: 600, lineHeight: 1.1}}>
                                PerFIL OCUPACIONAL
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                Programas prácticos diseñados para una empleabilidad rápida en sectores clave como
                                tecnología, administración, salud e industria
                                Programas prácticos diseñados para una empleabilidad rápida en sectores clave como
                                tecnología, administración, salud e industria
                            </Typography>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                            sx={{mt: 6}}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Perfil_Ocupacional/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Perfil_Ocupacional

const items = [1, 2, 3]